/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Action_Bar_RegistrationInputs */



/**
* | output |
* | --- |
* | "{count} players registered. Close registration when ready." |
*
* @param {Action_Bar_RegistrationInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const action_bar_registration = /** @type {((inputs: Action_Bar_RegistrationInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_Bar_RegistrationInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} joueurs inscrits. Fermez les inscriptions quand prêt.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} jugadores inscritos. Cierre las inscripciones cuando esté listo.`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.count} jogadores inscritos. Feche as inscrições quando estiver pronto.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} giocatori iscritti. Chiudi le iscrizioni quando sei pronto.`)
	return /** @type {LocalizedString} */ (`${i?.count} players registered. Close registration when ready.`)
});